"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendMoreInfoFail = exports.sendMoreInfoSuccess = exports.sendMoreInfoRequest = void 0;

var _needMoreInfo = require("./needMoreInfo.types");

var sendMoreInfoRequest = function sendMoreInfoRequest(_ref) {
  var info = _ref.info,
      giftId = _ref.giftId;
  return {
    type: _needMoreInfo.SEND_MORE_INFO_REQUEST,
    payload: {
      info,
      giftId
    }
  };
};

exports.sendMoreInfoRequest = sendMoreInfoRequest;

var sendMoreInfoSuccess = function sendMoreInfoSuccess(giftId) {
  return {
    type: _needMoreInfo.SEND_MORE_INFO_SUCCESS,
    payload: giftId
  };
};

exports.sendMoreInfoSuccess = sendMoreInfoSuccess;

var sendMoreInfoFail = function sendMoreInfoFail(error) {
  return {
    type: _needMoreInfo.SEND_MORE_INFO_FAILS,
    payload: error
  };
};

exports.sendMoreInfoFail = sendMoreInfoFail;